import index from "./activation.vue";
export default index;
